// extracted by mini-css-extract-plugin
export default {"infos":"infos_infos__ZCL2n","title":"infos_title__uwX3a","field":"infos_field__1Te6w","row":"infos_row__pld6+"};